// extracted by mini-css-extract-plugin
export default {"m":"Banner_m__7Qap5"};